var map = {
	"./as-c-fundamentalindicator-1.png": 20354,
	"./as-c-heatmap-gpt5.1.png": 40546,
	"./as-c-indicator-5.png": 75219,
	"./as-c-v4gpt5.1.png": 87873,
	"./as-c-v6.3.png": 64853,
	"./fs-c-vpvr.png": 71197,
	"./fs-c-vwaprsi.png": 20035,
	"./multi-timeframe-forex.png": 95982,
	"./technical-indicator-forex.png": 90809,
	"./technical-market-analysis-v6.png": 42427,
	"./technical-market-analysis-v7.2.png": 90246,
	"./technical-market-analysis.png": 33896,
	"./technical-market-indicator-2.png": 67858,
	"./technical-market-indicator-8.png": 72808,
	"./technical-market-indicator.png": 97919,
	"./technical-sentiment.png": 5180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51998;